import React, { useState, useRef, useEffect, useCallback } from "react";
import 'ag-grid-enterprise';
import { useNavigate, useParams } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import moment from 'moment';
import AgGridTable from "../../utilities/AgGridTable";

const Attendance = () => {

    const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.attendance}`;
    const perPage = 10;
    const params = useParams();
    const [rowData, setRowData] = useState();
    const [error, setError] = useState("")
    const gridRef = useRef();
    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }
    const [columnDefs, setColumnDefs] = useState([
        // { field: 'employeeId', enableRowGroup: true, },
        // { field: 'employeeName', enableRowGroup: true, },
        { field: 'attendanceCategory', enableRowGroup: true, },
        { field: 'attendanceDuration', enableRowGroup: true, },
        { field: 'logDate', enableRowGroup: true, cellRenderer : handleDateFormat },
        { field: 'logTimeIn', enableRowGroup: true, },
        { field: 'logTimeOut', enableRowGroup: true, },

    ]);

    const getAttendance = async () => {
        try {
            const res = await OAuthService.getList(url + '?sort=cityName,asc&size=1000');
            let attendanceInfoes = res.data._embedded.attendanceInfoes;
            attendanceInfoes = attendanceInfoes.map((attendance) => {
                const logTimeIn = moment(attendance.logTimeIn).format('hh:mm A');
                const logTimeOut = moment(attendance.logTimeOut).format('hh:mm A');
                attendance.logTimeIn = logTimeIn;
                attendance.logTimeOut = logTimeOut;
                return attendance;
            });
            const employeeAttendance = attendanceInfoes.filter((attendance)=> attendance.employeeId === params.id)
            setRowData(employeeAttendance);
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }
    useEffect(() => {
      if(params.id){
        getAttendance();
      }
    
    }, [params.id])
    


    return (
        <div style={{ height: '500px' }}>
            <AgGridTable
                rowData={rowData}
                columnDefs={columnDefs}
                gridRef={gridRef}
                paginationPageSize={perPage}
                cacheBlockSize={perPage}
                editable={false}
                saveGridStateName={'attendance-tab'}
            />
        </div>
    )
}

export default Attendance